import axios from 'axios'

function downloadFile(url, file, type, params) {
  const options = {
    headers: {'accept': type},
    responseType: 'blob',
    params
  };

  return axios.get(url, options).then(response => {
    const blob = new Blob([(response.data)], {type: type});
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.id = 'tmp-file-download';
    anchor.setAttribute('download', file);
    document.body.appendChild(anchor);
    anchor.click();
    document.getElementById(anchor.id).remove();
  });
}

export default {
  all: () => axios.get(`/api/shops`, { headers: {Accept: 'application/json'} }).then(response => response.data),
  findCompanies: () => axios.get(`/api/shops/search/companies`).then(result => result.data),
  add: (shop) => axios.post(`/api/shops`, shop),
  modifyShop: (code, shop) => axios.put(`/api/shops/${code}`, shop),
  downloadCsv: () => downloadFile(`/api/shops`, 'negozi.csv', 'text/csv')
}
